//App.js
import React from 'react'
import { NavigationContainer } from '@react-navigation/native'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
//import English from './English.js'
//import Português from './Português.js'
//import TextDesktop from './TextDesktop.js'
import TextMobile from './TextMobile.js'
//import TextPortuguês from './TextPortuguês.js'
import TextMobilePortuguês from './TextMobilePortuguês.js'
import LinkedInTag from 'react-linkedin-insight'

const Stack = createNativeStackNavigator();

const App = () => {
  //const disabled = !user.allowsThirdPartyCookies();
  //LinkedInTag.init(partnerId, 'dc', disabled);
  //LinkedInTag.track(conversionId);
  return (
    <NavigationContainer>
      <Stack.Navigator
        initialRouteName="TextMobile"
      >
        <Stack.Screen
          name="TextMobile"
          component={TextMobile}
          options={{ headerShown: false, title: 'marcioseno' }}
          //options={{ title: 'Login - SenoExperts' }}
        />
        <Stack.Screen
          name="TextMobilePortuguês"
          component={TextMobilePortuguês}
          options={{ headerShown: false, title: 'marcioseno'  }}
          //options={{ title: 'Login - SenoExperts' }}
        />
      </Stack.Navigator>
    </NavigationContainer>
  );
};
export default App;
/*
  <Stack.Screen
    name="English"
    component={English}
    options={{ headerShown: false }}
  />
  <Stack.Screen
    name="Português"
    component={Português}
    options={{ headerShown: false }}
    //options={{ title: 'Login - SenoExperts' }}
  />
  */
  /*
  <Stack.Screen
    name="TextDesktop"
    component={TextDesktop}
    options={{ headerShown: false }}
    //options={{ title: 'Login - SenoExperts' }}
  />
  */
  /*
  <Stack.Screen
    name="TextPortuguês"
    component={TextPortuguês}
    options={{ headerShown: false }}
    //options={{ title: 'Login - SenoExperts' }}
  />
  */
